<div class="row" *ngIf="pagination != null">
  <div class="col-6">
    <table class="table">
      <thead>
        <tr class="fw-bold">
          <th>Effective Date</th>
          <th>Type</th>
          <th>Amount</th>
          <th>Download</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let memo of data">
          <td class="fw-bold">
            {{ memo.EffectiveDate | date: 'MM/dd/yyyy' }}
          </td>
          <td>
            <span *ngIf="memo.CreditDebitAmount > 0" class="text-danger fw-bold">Debit</span>
            <span *ngIf="memo.CreditDebitAmount < 0" class="cp-green fw-bold">Refund</span>
          </td>
          <td class="fw-bold">
            <span>
              {{ memo.CreditDebitAmount | currency }}
            </span>
          </td>
          <td>
            <button (click)="download(memo)" class="btn btn-link-blue fw-bold">Download</button>
          </td>
        </tr>
      </tbody>
    </table>
    <lib-pagination
      class="mt-3"
      [pagination]="pagination"
      (pageChanged)="pageChanged($event)"></lib-pagination>
  </div>
</div>
